import request from '@/utils/request'
const apiPath = '/sys/sysStepLog'
const sysStepLogApi = {
  /**
   * 新增【步骤日志】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【步骤日志】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【步骤日志】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【步骤日志】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【步骤日志】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【快递配置】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
}
export default sysStepLogApi
